import React, { ReactNode, FunctionComponent } from 'react';
import { SharedIconCheck } from '../../../../../shared/icons';
import { ResidenceType } from '../../config';

export interface HousingCardProps {
  label: string;
  name: string;
  checked?: boolean | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultValue?: any;
  id: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  validation?: any;
  icon?: ReactNode;
  onClick?: (value: ResidenceType, label: string, name: string) => void;
}

export const HomeValueResidenceType: FunctionComponent<HousingCardProps> = ({
  id,
  name,
  validation,
  register,
  checked,
  defaultValue,
  label,
  icon,
  onClick = () => {
    console.log('No onClick function provided');
  }
}) => {
  return (
    <div>
      <input
        className="hidden peer"
        id={id}
        {...register(name, validation ? validation : {})}
        defaultChecked={checked}
        defaultValue={defaultValue}
        type="radio"
        role={`custom`}
      />

      <label
        className="flex relative flex-grow flex-col text-center p-12 lg:p-6 justify-center cursor-pointer border-2 rounded-md border-solid border-gray-100 checked: before:!hidden peer-checked:border-green-500"
        htmlFor={id}
        onClick={() => onClick(defaultValue, label, name)}>
        {icon && <span>{icon}</span>}

        <span className={`mt-6 lg:h-[40px] lg:leading-8`}>
          {label} {checked}
        </span>
        <span className={`absolute right-4 top-4 ${checked ? 'block' : 'hidden'}`}>
          <SharedIconCheck className="w-4 h-4" />
        </span>
      </label>
    </div>
  );
};
